import React, {  } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from "@material-ui/core/Grid/Grid";


import Typography from "@material-ui/core/Typography";
import AlarmesBarChart from "./AlarmesBarChart";




const useStyles = makeStyles(theme => ({

    mainGrid: {
      margin: 0,
      display: 'flex',
      height: '150mm',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      alignContent: 'flex-start',
      border: 1,
      borderStyle: 'solid',
      borderColor: 'black',
      borderRadius: '5px',
      flexGrow: 0
    },
    gridTitulo: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'flex-start',


        border: 1,
    //    borderStyle: 'solid',
        borderColor: 'black',
        borderRadius: '5px'
    },
    gridItem: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: "center",
        alignContent: 'center',
        border: 1,
   //     borderStyle: 'solid',
        borderColor: 'black',
        borderRadius: '5px'
    },


}));


export default function Alarmes(props) {
  const { raspaReportData} = props;

  const classes = useStyles();


    return (
    <Grid container xs={12} className={classes.mainGrid}>
        <Grid container item id={'titulo'} className={classes.gridTitulo} sm={12} md={12}>
            <Typography>ALARMES</Typography>
        </Grid>
        <Grid container item id={'gridCorrecaoAjuste'} className={classes.gridItem}  sm={12} md={12} >

            <AlarmesBarChart data={raspaReportData.periodo.alarmes}

                                  titulo={"TOP 10 ALARMES"}

                                  height={250} width={690}  maxBarSize={20}/>

        </Grid>
    </Grid>
  )
}
;
